import { render, staticRenderFns } from "./inline-audio.vue?vue&type=template&id=5a22a61f"
import script from "./inline-audio.vue?vue&type=script&lang=js"
export * from "./inline-audio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports